/*
 * Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
 * #  This file forms part of the Trade-DSM application frontend.
 * #  https://github.com/Tooblippe/trade-dsm-frontend
 */

// Main entry point for VUE application - JS portion
import Vue from 'vue';
import {store} from './store/store';

import router from './router';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueAxios from 'vue-axios';
// import jwt_decode from "jwt-decode";

// import VueLocalForage from 'vue-localforage';
const VueLocalForage = require('vue-localforage');
Vue.use(VueLocalForage);

// import reactiveStorage from 'vue-reactive-storage';
import App from './App.vue';
// Sentry Setup
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import {mapGetters, mapMutations} from 'vuex';
import VueFlags from '@growthbunker/vueflags';
import html2canvas from 'html2canvas';
import swal from 'sweetalert';
import vFmt from '@/components/application-level/mixins/vFmt';
import {handle_error} from '@/components/application-level/helper-components/error_handler';

const _ = require('lodash');

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);

Vue.use(VueFlags, {
  iconPath: '/flags',
});

axios.interceptors.request.use(function(config) {
  config.headers.Authorization = 'Bearer ' + localStorage.getItem('token');
  store.state.app.callsPending++;
  // console.log(`${store.state.app.callsPending} calls pending.`);
  return config;
});

axios.interceptors.response.use(function(response) {
  store.state.app.callsPending--;
  if (store.state.app.callsPending === 0) {
    // console.log('No more calls pending.');
  }
  return response;
}),
  function(error) {
    store.state.app.callsPending--;
    return Promise.reject(error);
  };

export const eventBus = new Vue();

// Sentry is our error logging system
// Only deploy in production
if (process.env.VUE_APP_SENTRY === 'true') {
  console.log('Sentry error logging enabled ...');
  Sentry.init({
    dsn: 'https://434142223bc54d80884db07f16d35f0a@sentry.io/2947316',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
  });
  Vue.config.silent = true;
} else {
  console.log('Sentry error logging not enabled ...');
}

Vue.component('dynamic-html', {
  props: ['html'],
  computed: {
    template() {
      if (this.html) return Vue.compile(this.html).render();
      return null;
    },
  },
  render() {
    if (this.template) return this.template();
    return null;
  },
});

Vue.mixin({
  data: () => ({
    max_results: '201',
    message: 'hi',
  }),
  mixins: [vFmt],
  watch: {},
  computed: {
    ...mapGetters([
      'productsList',
      'countriesSelectorList',
      'app_data',
      'productSearchAndSelectedList',
      'is_run_cube_valid',
    ]),

    custom_filter_settings() {
      if (localStorage.getItem('custom_filters_selected') === null) {
        localStorage.setItem(
          'custom_filters_selected',
          JSON.stringify({
            startup_value_list_ix: 0,
            current_value_list_ix: 0,
          }),
        );
      }
      return JSON.parse(localStorage.getItem('custom_filters_selected'));
    },
    // smaller helper functions here
    current_report_to_run() {
      return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .report_type_to_generate;
    },
    value_convertion: function() {
      // returns the value conversion constant for current number divider and excahnge rate
      return (1 / this.mulitplier) * this.exchangeRate;
    },

    currencyString: function() {
      // return the current currency string
      if ('Currency' in this.$store.state.app.exchange_rate) {
        return this.$store.state.app.exchange_rate['Currency'].slice(0, 3);
      } else {
        return '';
      }
    },
    exchangeRate: function() {
      return this.app_data.exchange_rate['TW_FX_Rate'];
    },
    untapped_potential: function() {
      return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
        .trade_value;
    },
    mulitplier: function() {
      return this.app_data.value_mulitplier['divider'];
    },
    multiplerString: function() {
      return this.app_data.value_mulitplier['prefix'];
    },
    multiplerStringLongName: function() {
      return this.app_data.value_mulitplier['long_name'];
    },

    //these two values is the total truth of the products, markets, selecitons etc
    productsSelectedCount() {
      return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
        .products.HS6_Code.length;
    },
    marketsSelectedCount() {
      return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
        .markets.C_Code.length;
    },

    countriesSearchAndSelectedList() {
      // blank list
      let full_list = [];
      // reference to the current filter results
      let filter_results = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .query_results.countries;

      let selections = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .selections.markets;

      // let sub_region_included = []
      // let main_region_included = []

      // iterate through the main product list
      //create a baclup list and remove the home market
      let countries_backup_list_remove_home = this.countriesSelectorList.filter(
        v =>
          v.C_Code !==
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.home_market,
      );

      let remember_Main_Region_in_cube = [];
      let remember_Sub_Region_in_cube = [];

      for (let i = 0; i < countries_backup_list_remove_home.length; i++) {
        // check if in the cube results and add key
        let country_item = countries_backup_list_remove_home[i];
        if (country_item['In_Results']) {
          country_item['in_cube'] = false;
          country_item['in_search'] = true;
          country_item['C_Code_Selected'] = false;
          country_item['Main_Region_Selected'] = false;
          country_item['Main_Region_in_cube'] = false;
          country_item['Sub_Region_Selected'] = false;
          country_item['Sub_Region_in_cube'] = false;
          country_item['Trade_Group_Selected'] = false;
          country_item['C_Name_2'] = countries_backup_list_remove_home[i]['C_Name'];

          // iterate through the countries if there is a list and put them all in the cube
          for (let search = 0; search < filter_results.length; search++) {
            let search_item = filter_results[search];

            if (country_item['C_Code'] === search_item) {
              country_item['in_cube'] = true;
              country_item['Main_Region_in_cube'] = true;
              country_item['Sub_Region_in_cube'] = true;
              remember_Main_Region_in_cube.push(country_item['Main_Region']);
              remember_Sub_Region_in_cube.push(country_item['Sub_Region']);
            }
          }
          //override all if the list is empty then all is selected by default, otherwise everything is in the cube
          if (filter_results.length === 0) {
            country_item['in_cube'] = true;
          }

          // selected?
          // iterate through the 4 keys
          // ['C_Code', 'Sub_Region', 'Main_Region',  'Trade_Group'].forEach(key => {
          ['C_Code', 'Sub_Region', 'Main_Region'].forEach(key => {
            for (let selection = 0; selection < selections[key].length; selection++) {
              let selected_term = selections[key][selection];
              if (country_item[key] === selected_term) {
                if (country_item[`${key}_Selected`]) {
                  country_item[`${key}_Selected`] = false;
                  //need to remove from the selections list then
                  // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                  this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets[
                    key
                  ] = [
                    ...this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets[
                      key
                    ].filter(v => v !== selected_term),
                  ];
                } else {
                  country_item[`${key}_Selected`] = true;
                }
              }
            }
          });
          full_list.push(country_item);
        }
      }

      remember_Main_Region_in_cube = _.uniq(remember_Main_Region_in_cube);
      remember_Sub_Region_in_cube = _.uniq(remember_Sub_Region_in_cube);

      // remember_Sub_Region_in_cube.push('Eastern Asia');
      // remember_Main_Region_in_cube.push('Eastern Asia');

      // console.log(remember_Main_Region_in_cube);
      // console.log(remember_Sub_Region_in_cube);

      full_list.forEach(v => {
        if (remember_Main_Region_in_cube.includes(v.Main_Region)) {
          v['Main_Region_in_cube'] = true;
        }
        if (remember_Sub_Region_in_cube.includes(v.Sub_Region)) {
          v['Sub_Region_in_cube'] = true;
        }
      });

      return full_list;
    },

    //
    advanved_filter_in_progress: function() {
      // returns true when advanced filters where used, or busy being used until reset

      return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .filter_in_progress;
    },
  },
  methods: {
    ...mapMutations([
      'set_dsm_filters_loading',
      'set_dsm_filters',
      'set_dsm_filters_meta',
      'setCombinationsTradeValue',
      'set_filter_box_selection_country',
      'set_filter_box_selection_product',
      'set_advanced_filters_is_dirty',
      'clear_circ_ref_error',
      'set_selectors_state',
      'set_user_message',
      'set_results_cube_to_empty',
    ]),
    institution_image_url() {
      // what instition image is being used
      let ctx = require.context('./assets/img/application/', true, /\.png$/);
      return ctx(
        this.$store.state.user.userServerInfo.user.fields.institution[0].fields
          .application_image,
      );
      // '../assets/img/application/' +this.$store.state.user.userServerInfo.user.fields.institution[0].fields
      //           .application_image
    },

    loader_institution_image_url() {
      // who was the sender company trade advisory or aexi - this is for the graph image
      const {isAexiFamily} = require('@/components/application-level/js_functions/referrer-utils');

      let ctx = require.context('./assets/img/application/', true, /\.png$/);
      let image = 'Trade-Advisory-Logo2.png';
      if (isAexiFamily(localStorage.getItem('reload_url'))) {
        image = 'AEXI_Logo.png';
      }
      return ctx('./' + image);
    },
    code_to() {
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code !== undefined &&
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code.length > 0
      ) {
        return this.$store.getters.productsList.filter(
          c =>
            c['HS6_Code'] ===
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
              .products.HS6_Code[0],
        )[0];
      } else {
        return {
          HS6_Code: '',
          HS6_Description: '',
        };
      }
    },
    totalValueString: function(trade_value_dollar) {
      return `${this.currencyString} ${this.vFmt(
        trade_value_dollar * this.value_convertion,
        2,
      )} ${this.multiplerString}`;
    },
    totalValueStringHTML: function(trade_value_dollar) {
      return `${this.currencyString} <br> ${this.vFmt(
        trade_value_dollar * this.value_convertion,
        2,
      )} <br>${this.multiplerStringLongName}`;
    },

    // helper functions
    codeToMarket(C_Code) {
      if (C_Code !== '-' && C_Code !== undefined && C_Code !== null) {
        return this.countriesSelectorList.filter(v => v.C_Code === C_Code)[0]['C_Name'];
      } else {
        return '-';
      }
    },

    marketToCode(C_Name) {
      try {
        if (C_Name !== '-') {
          return this.countriesSelectorList.filter(v => v.C_Name === C_Name)[0]['C_Code'];
        } else {
          return '';
        }
      } catch (e) {
        return '';
      }
    },
    codeToISO(C_Code) {
      if (C_Code !== '-' || C_Code !== '') {
        return this.countriesSelectorList.filter(v => v.C_Code === C_Code)[0][
          'C_Code_ISO_Alpha_2'
        ];
      } else {
        return '';
      }
    },
    codeToMain_Region(C_Code) {
      return this.countriesSelectorList.filter(v => v.C_Code === C_Code)[0][
        'Main_Region_Code'
      ];
    },
    codeToSub_Region_Code(C_Code) {
      return this.countriesSelectorList.filter(v => v.C_Code === C_Code)[0][
        'Sub_Region_Code'
      ];
    },
    hs6_codeToDescription(HS6_Code) {
      // return this.productsList.filter(p => p.HS6_Code === HS6_Code)[0]['HS6_Description'];
      return this.$store.state.tradeDSM.hs6_to_desc_hash_map[HS6_Code];
    },
    hs6_SIC_code(HS6_Code) {
      // console.log(this.productsList.filter(p => p.HS6_Code === HS6_Code)[0]['SIC27']);
      return this.productsList.filter(p => p.HS6_Code === HS6_Code)[0]['SIC27'];
    },
    hs6_SIC_code_description(HS6_Code) {
      return this.productsList.filter(p => p.HS6_Code === HS6_Code)[0][
        'SIC27_Description'
      ];
    },
    hs4_codeToDescription(HS4_Code) {
      return this.productsList.filter(p => p.HS4_Code === HS4_Code)[0]['HS4_Description'];
    },
    hs2_codeToDescription(HS2_Code) {
      return this.productsList.filter(p => p.HS2_Code === HS2_Code)[0]['HS2_Description'];
    },

    resp_config: function() {
      return {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
      };
    },
    // numberWithCommas: function (x) {
    //     return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // },
    array_value_conversion: function(arr, conv_array) {
      if (conv_array === null) {
        return arr.map(v =>
          v !== 'nan'
            ? (
                v *
                ((1 / this.app_data.value_mulitplier['divider']) *
                  this.app_data.exchange_rate['TW_FX_Rate'])
              ).toFixed(2)
            : null,
        );
      } else if (conv_array === 'time_weighted') {
        // multuply each element with time weighted

        let multiplier = this.app_data.value_mulitplier['divider'];
        // let selected_currency = this.$store.state.app.exchange_rate['Currency'];
        let left = arr;
        let right = this.$store.state.user.userServerInfo.non_tw_exchange_rate.filter(
          v => v['Currency'] === this.app_data.exchange_rate['Currency'],
        );

        right = right.slice(Math.max(right.length - 5, 0));
        let values = [];
        for (let i = 0; i < left.length; i++) {
          values.push(((left[i] * right[i]['FX_Rate']) / multiplier).toFixed(2));
        }
        // console.log(values);
        return values;
      }
    },

    async reset_filters_to_raw_state() {
      eventBus.$emit('CLEAR_MARKETS_TOP_LIST');
      eventBus.$emit('CLEAR_PRODUCTS_TOP_LIST');
      eventBus.$emit('CLEAR_REO_TABLE');

      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress = false;
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty = false;
      this.$store.state.tradeDSM.last_clicked_country_box = null;

      await this.reset_filters('FILTERS');

      this.$store.state.tradeDSM.quick_selectors[1].items = await JSON.parse(
        localStorage.getItem('dsm_codes'),
      );
      this.set_user_message(
        'All presets filters, exclusions and selections have been cleared.',
      );
      this.update_mpmc_graphs(); //graphs underneath map
    },
    //----------------------------

    // Filters update functions
    // Function to load all the filters from the backend
    load_dsm_filters: async function(
      home_market,
      model_number,
      countries,
      products,
      institution_id,
      standard_filter_id,
    ) {
      // function to update the filters
      // enter home market code and model number 00, 01 etc. (str)
      // takes list of countries in comma seperated values
      // countries = all and products=all for all values
      console.log('Requesting dsm filters ...');

      // if (localStorage.getItem('FILTERS') === null) {
      this.$store.commit('set_dsm_filters_loading', true);

      const filter_url = this.$store.getters.baseUrl +
            this.$store.state.tradeDSM.get_filters_url +
            home_market +
            '/' +
            model_number +
            '/' +
            countries +
            '/' +
            products +
            '/' +
            institution_id +
            '/' +
            standard_filter_id +'/'

      // alert(filter_url)
      await this.axios
        .get(filter_url,
          this.resp_config(),
        )
        .then(response => {
          console.log('FILTERS');

          // console.log(response.data)
          console.log('Filters loaded from serverzzz ...');

          this.set_dsm_filters_loading(false); // enable view on leftside bar
          this.set_dsm_filters(response.data); //set filters
          localStorage.setItem('FILTERS', JSON.stringify(response.data));
          console.log(response.data);
        })
        .catch(e => {
          console.log('error loading filters.' + e);
        });
      return 'ok';
    },

    // update
    update_filters_selection: async function(force_run_update = false) {
      // force_run_update = doesnt matter what the update settings is,update the values
      //                  = this is needed when in the box and update clicked

      let update_filters_selection_on_each_call = this.$store.state.app
        .update_filters_selection_on_each_call;
      // skip this step looks in settings
      // if skip is true then it wil run, but fore_run_update_will overide it

      if (force_run_update || update_filters_selection_on_each_call) {
        // obtain the new set of parameters given the current filters
        this.clear_circ_ref_error();
        let update_data = this.$store.state.tradeDSM.dsm_filter_setttings.Filters;
        this.filters_updating = true;

        this.$store.state.tradeDSM.updatingMainFilters = true;
        await this.axios
          .post(this.$store.getters.baseUrl + 'update_filters/', update_data)
          .then(response => {
            // note - don't set the whole object here ... everything except META
            this.set_dsm_filters(response.data);
            this.filters_updating = false;
            this.$store.state.tradeDSM.updatingMainFilters = false;
            this.set_filter_box_selection_country([]);
            this.set_filter_box_selection_product([]);
          })
          .catch(e => {
            handle_error({
              code: 'filters_selection_update_error',
              message: e.message,
            });

            console.log(e);
            console.log(update_data);
            this.filters_updating = false;
            this.$store.state.tradeDSM.updatingMainFilters = false;
            swal.close();
          });
      }
      swal.close();
      this.filters_updating = false;
      this.$store.state.tradeDSM.updatingMainFilters = false;

      this.set_filter_box_selection_country([]);
      this.set_filter_box_selection_product([]);

      return Promise.resolve(2);
    },

    run_dsm_advanced_query: async function() {
      //
      this.set_results_cube_to_empty();
      //
      this.$store.state.product_preselected_by_app = false;
      this.$store.state.market_preselected_by_app = false;
      this.filters_updating = true;
      this.clear_circ_ref_error();

      const data = this.$store.state.tradeDSM.dsm_filter_setttings.Filters;

      data['META'][
        'home_market_name'
      ] = this.$store.state.user.userServerInfo.subscriptions[0].subscription.home_market_name;

      // data['META']['home_market_name'] =
      //   this.$store.state.tradeDSM.dsm_filter_setttings.Home_Market;

      this.$store.state.tradeDSM.loading_indicator = true;

      await this.axios
        .post(this.$store.getters.baseUrl + 'run_dsm_advanced_query/', data)
        .then(response => {
          this.set_dsm_filters(response.data);
          this.filters_updating = false;
          this.setCombinationsTradeValue(response.data['META']['combinations']);
          this.set_filter_box_selection_country([]);
          this.set_filter_box_selection_product([]);
          this.$store.state.tradeDSM.loading_indicator = false;

          // if the result comes back as only 1 product and/or one market, make a preselection
          if (
            this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results
              .products_count === 1
          ) {
            if (
              this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                .products.HS6_Code.length === 0
            ) {
              this.$store.state.product_preselected_by_app = true;
              this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.products;
            }
          }

          if (
            this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results
              .markets_count === 1
          ) {
            if (
              this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                .markets.C_Code.length === 0
            ) {
              this.$store.state.market_preselected_by_app = true;
              this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.countries;
            }
          }
        })
        .catch(e => {
          console.error('Error in run_dsm_advanced_query, main.js, +- 439');
          console.error(e);

          this.filters_updating = false;
          this.$store.state.tradeDSM.loading_indicator = false;
        })
        .finally(() => {
          swal.close();
        });
    },

    getCircularReplacer() {
      const seen = new WeakSet();
      return (key, value) => {
        if (typeof value === 'object' && value !== null) {
          if (seen.has(value)) {
            return;
          }
          seen.add(value);
        }
        return value;
      };
    },

    show_loading_messsage(msg) {
      swal({
        text: msg,
        buttons: false,
        closeOnClickOutside: false,
        icon: 'info',
        className: 'swal-modal',
        closeOnEsc: false,
      });
    },

    async update_mpmc_graphs() {
      eventBus.$emit('TRIGGER_ALL_EXPORTER_IMPORTER_GRAPHS'); //graphs underneath map
      eventBus.$emit('TRIGGER_REO_EXPORTER_IMPORTER_GRAPHS'); //graphs underneath map
    },

    async get_non_1p1c_result_valid_cube(close_open_boxes) {
      // this.set_results_cube_to_empty();
      // const report_type = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
      //   .report_type_to_generate;
      this.show_loading_messsage(
        'Updating filters.\n\nPlease be patient. This step can take some time.',
      );
      const remember_filter_in_progress = this.$store.state.tradeDSM.dsm_filter_setttings
        .Filters.META.filter_in_progress;
      const remember_advanced_filters_is_dirty = this.$store.state.tradeDSM
        .dsm_filter_setttings.Filters.META.advanced_filters_is_dirty;
      this.set_user_message('Updating filters');

      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
          .combinations !== 0
      ) {
        // yes
        this.message = 'Getting cubes';

        this.show_loading_messsage(
          'Extracting results cubes.\n\nPlease be patient. This step can take some time.',
        );
        this.set_user_message('Extracting data cubes');

        if (this.current_report_to_run === 'MPMC' && this.is_run_cube_valid) {
          eventBus.$emit('RUN_REO_MPMC_SOLVE_NO_MOUNT');
        }

        this.run_dsm_advanced_query_update_filters()
          .then(() => {
            if (close_open_boxes === true) {
              this.$store.state.tradeDSM.countriesOpen = false;
              this.$store.state.tradeDSM.productsOpen = false;
            }

            this.update_filters_selection();
            this.loading = false;
            this.set_user_message('Ready');

            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress = remember_filter_in_progress;
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty = remember_advanced_filters_is_dirty;
          })
          .finally(() => {
            swal.close();
          });
      } else {
        console.log('No results, so not doing advanced update');
        swal.close();
        this.loading = false;
        this.set_user_message('Ready');
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress = remember_filter_in_progress;
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty = remember_advanced_filters_is_dirty;
      }
    },

    async get_non_1p1c_result_non_valid_cube(
      remember_filter_in_progress,
      remember_advanced_filters_is_dirty,
      close_open_boxes,
    ) {
      this.set_user_message('Updating filters');

      // this.show_loading_messsage(
      //   'Updating filters .\n\nPlease be patient. This step can take some time.',
      // );

      this.update_filters_selection()
        .then(() => {
          this.loading = false;

          if (close_open_boxes === true) {
            this.$store.state.tradeDSM.countriesOpen = false;
            this.$store.state.tradeDSM.productsOpen = false;
          }
          swal.close();
          this.set_user_message('Ready');
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress = remember_filter_in_progress;
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty = remember_advanced_filters_is_dirty;
        })
        .finally(() => {
          swal.close();
        });
    },

    async get_1p1c_valid_cube(
      remember_filter_in_progress,
      remember_advanced_filters_is_dirty,
    ) {
      this.set_selectors_state(false);

      this.show_loading_messsage(
        'Loading single product and market combinations.\n\nPlease be patient. This step can take some time.',
      );
      ///// put selection in correct place

      ///
      this.update_filters_selection();
      await this.get_1p1c_front_end_data();
      this.set_selectors_state(true);
      this.loading = false;
      swal.close();
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress = remember_filter_in_progress;
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty = remember_advanced_filters_is_dirty;
    },

    run_dsm_advanced_query_update_filters: async function() {
      this.$store.state.tradeDSM.loading_indicator = true;
      this.clear_circ_ref_error();
      let data = this.$store.state.tradeDSM.dsm_filter_setttings.Filters;

      await this.axios
        .post(
          this.$store.getters.baseUrl + 'run_dsm_advanced_query_update_filters/',
          data,
          this.resp_config(),
        )
        .then(async response => {
          // set the META results
          // if (!('empty' in response.data)) {
          //   // this is not an empty answer
          //   await this.clear_circ_ref_error();
          //   this.set_dsm_filters_meta(response.data['META']);
          //   this.setCombinationsTradeValue({...response.data['META']['combinations']});
          //   this.$store.state.tradeDSM.loading_indicator = false;
          // } else {
          //   console.log(`No results in the cube`);
          //   await this.clear_circ_ref_error();
          //   this.filters_updating = false;
          //   this.$store.state.tradeDSM.loading_indicator = false;
          // }

          // if (1 + 1 == 2) {
          // this is not an empty answer
          const response_data = response.data;
          console.log(response_data);
          console.log(response_data);
          console.log(response_data);

          await this.clear_circ_ref_error();
          this.set_dsm_filters_meta(response_data['META']);
          this.setCombinationsTradeValue({...response_data['META']['combinations']});
          this.$store.state.tradeDSM.loading_indicator = false;
          // } else {
          //   console.log(`No results in the cube`);
          //   await this.clear_circ_ref_error();
          //   this.filters_updating = false;
          //   this.$store.state.tradeDSM.loading_indicator = false;
          // }
        })
        .catch(e => {
          console.log(`Error in run_dsm_advanced_query(), line 506, ${e}`);
          this.filters_updating = false;
          this.$store.state.tradeDSM.loading_indicator = false;
          swal.close();
        })
        .finally(async () => {
          await this.clear_circ_ref_error();
          swal.close();
          return Promise.resolve(3);
        });
    },

    async update_results_cube(close_open_boxes = true) {
      //

      const remember_filter_in_progress = this.$store.state.tradeDSM.dsm_filter_setttings
        .Filters.META.filter_in_progress;

      const remember_advanced_filters_is_dirty = this.$store.state.tradeDSM
        .dsm_filter_setttings.Filters.META.advanced_filters_is_dirty;

      this.set_user_message('Updating results cube.');

      if (this.$store.state.tradeDSM.apply_transaction) {
        this.$store.state.app.disable_getters = true;

        this.show_loading_messsage(
          'Loading product and market combinations.\n\nPlease be patient. This step can take some time.',
        );

        // get basic cube
        // this.set_results_cube_to_empty(); //exporimental make the query object smaller before the time.

        await this.run_dsm_advanced_query();

        const run_cube = this.is_run_cube_valid;

        const report_type = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
          .report_type_to_generate;

        if (report_type !== '1P1C') {
          //trigger parralel run of the graphs undernath the maps.

          if (run_cube === true) {
            this.$store.state.app.disable_getters = true;

            // Valid non 1P1C
            if (
              report_type === 'MP1C' ||
              report_type === 'MPMC' ||
              report_type === '1PMC'
            ) {
              eventBus.$emit('UPDATE_REO_TABLE');
              // eventBus.$emit('CLEAR_REO_TABLE'); // forces the REO table to rerun if it is a solved cube
            }

            this.get_non_1p1c_result_valid_cube(close_open_boxes)
              .then(() => {
                this.update_mpmc_graphs().then(() => {
                  swal.close();
                  this.loading = false;
                });
              })
              .finally(() => {});
          } else {
            // Non cube NON 1P1C
            this.get_non_1p1c_result_non_valid_cube(
              remember_filter_in_progress,
              remember_advanced_filters_is_dirty,
              close_open_boxes,
            ).then(() => {
              this.update_mpmc_graphs().then(() => {
                this.$store.state.app.disable_getters = false;
                swal.close();
              });
            });
          }
        } else {
          // 1P1C
          await this.get_1p1c_valid_cube(
            remember_filter_in_progress,
            remember_advanced_filters_is_dirty,
          ).then(() => {
            this.$store.state.app.disable_getters = false;
            swal.close();
          });
        }
      }

      // Cleanup code
      // reset report view
      this.$store.state.tradeData.report_selection = this.$store.state.tradeData.report_selections[0][
        'value'
      ];
      this.$store.state.current_1PMC_report_seletion = 'EMF_Overview';
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress = remember_filter_in_progress;
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty = remember_advanced_filters_is_dirty;
      swal.close();
    },
    // ------------------------
    // ------------------------
    // ------------------------
    // ------------------------
    reset_filters: async function(filter_state) {
      swal('Resetting filters.', {
        buttons: false,
        timer: 2000,
        icon: 'info',
      });
      await this.set_dsm_filters(JSON.parse(localStorage.getItem(filter_state)));
      this.$store.state.tradeDSM.updatingMarketProductCombinations = true;
      await this.set_filter_box_selection_country([]);
      this.$store.state.tradeDSM.loading_indicator = false;
      await this.set_filter_box_selection_product([]);
      await this.setCombinationsTradeValue(
        JSON.parse(localStorage.getItem(filter_state))['META']['combinations'],
      );
      this.$store.state.tradeDSM.loading_indicator = true;

      // this.set_advanced_filters_is_dirty(false);
      this.$store.state.tradeDSM.loading_indicator = false;
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress = false;
      this.$store.state.tradeDSM.updatingMarketProductCombinations = false;
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube = [];

      this.$store.state.tradeDSM.preset_markets_selection = {};
    },

    async reset_filters_to_preset_state(include_preset_list = true) {
      swal({
        text: 'Resetting filters to preset state. ',
        buttons: false,
        closeOnClickOutside: false,
        icon: 'info',
        className: 'swal-modal',
        closeOnEsc: false,
      });

      this.load_preset(include_preset_list)
        .then(() => {
          // await this.update_results_cube()
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.load_presets = include_preset_list;
          this.set_user_message('All presets filters and exclusions have been restored.');
        })
        .finally(
          (this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.load_presets = include_preset_list),
        );
    },

    clear_preset_filters: async function(close_open_boxes = true) {
      // const preset =
      //     this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.filters;
      // const filter_headings = ['F1', 'F2', 'F3', 'F4'];
      // const filters = this.$store.state.tradeDSM.dsm_filter_setttings.Filters;
      // await filter_headings.forEach(heading => {
      //     preset.forEach(preset_v => {
      //         filters[heading].entries.forEach(filter => {
      //             if (filter.col_name === preset_v.col_name) {
      //                 filter.selected_value = [];
      //             }
      //         });
      //     });
      // });

      await ['F1', 'F2', 'F3', 'F4'].forEach(heading => {
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters[heading].entries.forEach(
          filter => {
            // filter.selected_value = [];
            // console.log(filter.selected_value)
            filter.selected_value.splice(0);
            // console.log(filter.selected_value)
          },
        );
      });

      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.custom_query = {};

      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.PROVINCIAL_FILTER_VALUE = [
        0,
        100,
      ];
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress = false;
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty = false;
      await this.update_results_cube(close_open_boxes);
      this.set_user_message('Filters cleared.');
    },
    load_preset: async function(
      include_presets_list = true,
      force_filter_update = false,
    ) {
      let preset = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets
        .filters;
      let filter_headings = ['F1', 'F2', 'F3', 'F4'];
      let filters = this.$store.state.tradeDSM.dsm_filter_setttings.Filters;

      await filter_headings.forEach(heading => {
        preset.forEach(preset_v => {
          filters[heading].entries.forEach(filter => {
            if (filter.col_name === preset_v.col_name) {
              filter.selected_value = preset_v.selected_values;
            }
          });
        });
      });
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.PROVINCIAL_FILTER_VALUE = [
        parseFloat(
          this.$store.state.user.userServerInfo.user.fields.institution[0].fields[
            'provincial_share_level'
          ].toString(),
        ) * 100,
        100,
      ];

      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress = true;
      console.log(include_presets_list);
      this.$forceUpdate();

      swal({
        text:
          'Applying default filters .\n\nPlease be patient. This step can take some time.',
        buttons: false,
        closeOnClickOutside: false,
        icon: 'info',
        className: 'swal-modal',
        closeOnEsc: false,
      });

      if (force_filter_update === true) {
        console.log('forcing filters ');
        this.update_filters_selection().then(async () => {
          this.update_results_cube().then(() => {
            swal.close();
          });
        });
      } else {
        await this.update_results_cube(false);
      }
    },

    make_url(route) {
      const url = this.$store.getters.baseUrl;
      // console.log('Getting - /dsm_view_1p1c/' + route);

      return (
        url +
        'dsm_view_1p1c/' +
        route +
        '/' +
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.home_market +
        '/' +
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code[0] +
        '/' +
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code[0] +
        '/' +
        this.$store.state.app.selectedModelVersion
      );
    },
    async get_1p1c_front_end_data() {
      this.clear_circ_ref_error();

      // move the result (by this time we know there is only one, to be position one in the selection array so that the legacy code
      // that looks at selection[0] can use the correct resultant product / market
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code.length > 1
      ) {
        // // there is only one result but the seletion is not in correct possition in array
        // let answer_index = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code.indexOf(
        //   this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results
        //     .countries[0],
        // );
        //
        // // remove this item from the selections
        // this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code.splice(
        //   answer_index,
        //   1,
        // );
        //
        // //move it to the front
        // this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code.splice(
        //   0,
        //   0,
        //   this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results
        //     .countries[0],
        // );
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.countries;
      }

      // move the result (by this time we know there is only one, to be position one in the selection array so that the legacy code
      // that looks at selection[0] can use the correct resultant product / market
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code.length > 1
      ) {
        // there is only one result but the seletion is not in correct possition in array
        // let answer_index = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code.indexOf(
        //   this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results
        //     .products[0],
        // );
        //
        // // remove this item from the selections
        // this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code.splice(
        //   answer_index,
        //   1,
        // );
        //
        // //move it to the front
        // this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code.splice(
        //   0,
        //   0,
        //   this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results
        //     .products[0],
        // );
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.products;
      }
      // ----

      const C_Code_length = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .combinations.markets_count;

      const HS6_Code_length = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .combinations.products_count;

      if (C_Code_length >= 0 && HS6_Code_length >= 0) {
        this.$store.commit('setLoadingIndicator', true);
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations.markets_count = 1;
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations.products_count = 1;
        this.g1 = false;
        this.g2 = false;
        this.g3 = false;
        this.g4 = false;

        // let resp_config = {};

        //this data is sent to backend to assist in making the text writeups
        let data = {};
        data['target_market'] = this.codeToMarket(
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
            .C_Code[0],
        );
        // data['selections'] = selection;

        data['home_market'] = this.$store.state.app.selectedHomeCountry;
        data['sub_model_name'] = this.$store.state.app.selectedModelName;

        data['magnitude'] = this.$store.state.app.value_mulitplier;
        data['exchange_rate_tw'] = this.$store.state.app.exchange_rate;

        data = JSON.parse(JSON.stringify(data));

        // this.axios.post(this.make_url('dsm'), data, this.resp_config()),
        console.log('will be asking for 1P1C view data');
        await this.axios
          .all([
            this.axios.post(this.make_url('dsm'), data),
            this.axios.get(this.make_url('top6')),
            this.axios.get(this.make_url('hist_impexp_tm')),
            this.axios.get(this.make_url('hist_impexp_total')),
          ])
          .then(
            this.axios.spread((first, second, third, fourth) => {
              this.$store.commit('setDSMResult', first.data);
              this.$store.commit('setTop6Result', second.data);
              this.$store.commit('setHistImpExpTmResult', third.data);
              this.$store.commit('setHistImpexpTotalResult', fourth.data);
              this.$store.commit('setLoadingIndicator', false);
              // this.update_filters_selection();
              this.searchDone = true;
            }),
          )
          .catch(
            this.axios.spread((first, second, third, fourth) => {
              if (first) {
                this.$store.commit('setDSMResult', [{result: 'error'}]);
              }
              if (second) {
                this.$store.commit('setTop6Result', [{result: 'error'}]);
              }
              if (third) {
                this.$store.commit('setHistImpExpTmResult', [{result: 'error'}]);
              }
              if (fourth) {
                this.$store.commit('setHistImpexpTotalResult', [{result: 'error'}]);
              }
            }),
          )
          .finally(() => {
            // console.log('all went well on 1P1C why is the view broken then')
            this.$store.state.tradeDSM.updatingMarketProductCombinations = false;
          });
      } else {
        await swal.close();
        await swal.close();
      }
    },
    element2clipboard: async function(element_id, scroll_up = true) {
      // Renders the element with id = element_id to clipboard
      // there is a div directive to switch off an element

      if (scroll_up === true) {
        await window.scroll(0, 0);
      }
      html2canvas(document.getElementById(element_id), {
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        profile: true,
        backgroundColor: 'white',
      })
        .then(canvas => {
          this.image_uri = canvas.toDataURL('image/png');

          // add to clipboard
          fetch(this.image_uri)
            .then(res => res.blob())
            .then(blob => {
              navigator.clipboard.write([
                // eslint-disable-next-line no-undef
                new ClipboardItem({
                  'image/png': blob,
                }),
              ]);

              swal({
                title: 'Image copied to clipboard.',
                icon: this.image_uri,
                className: 'screenshot',
              });
            });
        })
        .catch(e => {
          console.error('Error taking screen shot', e);
        });
    },
    get_countries: async function() {
      // eslint-disable-next-line no-console

      // check for countries in local storage
      if (localStorage.getItem('dsm_countries') === null) {
        console.log('Getting countries from backend ...');
        let resp_config = {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        };
        await this.axios
          .get(
            this.$store.getters.baseUrl + this.$store.state.tradeDSM.get_countries_url,
            resp_config,
          )
          .then(async response => {
            let countries = response.data;

            await localStorage.setItem('dsm_countries', JSON.stringify(countries));
            console.log('Countries Loaded Success');
            // insert the in or out of
            await this.$store.commit('setCountriesList', countries);
            // this.loading_countries = false;
          });
        return Promise.resolve(2);
      } else {
        console.log('Countries found in storage ...');
        await this.$store.commit(
          'setCountriesList',
          JSON.parse(localStorage.getItem('dsm_countries')),
        );
        return Promise.resolve(2);
      }
    }, //get_countries

    async build_hs6_desc_hasgmap() {
      // now set the hash key for "HSCode" : "Desc"
      let product_list = await JSON.parse(localStorage.getItem('dsm_codes'));
      let hs6_hash_map = {};
      let hs4_hash_map = {};
      let hs2_hash_map = {};
      let hs2_group_hash_map = {};

      let hs4_to_hs6_map = {};

      let hs2_to_hs4_map = {};
      let hs4_iterator = -1;

      let hs2_groups_to_hs2_map = {};
      let hs2_iterator = -1;

      for (let ix = 0; ix < product_list.length; ix++) {
        let item = product_list[ix];
        hs6_hash_map[item['HS6_Code']] = item['HS6_Description'];
        hs4_hash_map[item['HS4_Code']] = item['HS4_Description'];
        hs2_hash_map[item['HS2_Code']] = item['HS2_Description'];
        hs2_group_hash_map[item['HS2_Groups']] = item['HS2_Groups'];

        // hs4_to_hs6
        if (item['HS4_Code'] in hs4_to_hs6_map) {
          hs4_to_hs6_map[item['HS4_Code']].push(ix);
        } else {
          hs4_to_hs6_map[item['HS4_Code']] = [ix];
          hs4_iterator = hs4_iterator + 1; // a new hs4 code was found
        }

        // hs2_to_hs4
        if (item['HS2_Code'] in hs2_to_hs4_map) {
          hs2_to_hs4_map[item['HS2_Code']].push(hs4_iterator);
        } else {
          hs2_to_hs4_map[item['HS2_Code']] = [hs4_iterator];
          hs2_iterator = hs2_iterator + 1;
        }

        // hs2_groups_to_hs2
        if (item['HS2_Groups'] in hs2_groups_to_hs2_map) {
          hs2_groups_to_hs2_map[item['HS2_Groups']].push(hs2_iterator);
        } else {
          hs2_groups_to_hs2_map[item['HS2_Groups']] = [hs2_iterator];
        }

        this.$store.state.tradeDSM.hs6_to_desc_hash_map = hs6_hash_map;
        this.$store.state.tradeDSM.hs4_to_desc_hash_map = hs4_hash_map;
        this.$store.state.tradeDSM.hs2_to_desc_hash_map = hs2_hash_map;
        this.$store.state.tradeDSM.hs2_group_to_desc_hash_map = hs2_group_hash_map;
        //
        this.$store.state.tradeDSM.hs4_to_hs6_map = hs4_to_hs6_map;
        this.$store.state.tradeDSM.hs2_to_hs4_map = hs2_to_hs4_map;
        this.$store.state.tradeDSM.hs2_groups_to_hs2_map = hs2_groups_to_hs2_map;

        //
      }
    },
    get_hscodes: async function() {
      // check for countries in local storage
      // eslint-disable-next-line no-console
      // alert('in loading hs_codes');

      if (localStorage.getItem('dsm_codes') === null) {
        // alert('key does not exist');
        let resp_config = {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        };

        this.axios
          .get(
            this.$store.getters.baseUrl + this.$store.state.tradeDSM.get_hsm_codes_url,
            resp_config,
          )
          .then(async response => {
            let products = response.data;

            await localStorage.setItem('dsm_codes', JSON.stringify(products));
            console.log('Products Loaded Success');
            await this.$store.commit('setDsmCodesList', products);

            localStorage.setItem('dsm_codes', JSON.stringify(products));
            console.log('Products Loaded Success');
            this.$store.commit('setDsmCodesList', products);
          })
          .catch(e => {
            alert('Loading DSM products information took to long, please refresh.');
            let products = null;
            localStorage.setItem('dsm_codes', JSON.stringify(products));
            alert(e);
          });
        // .finally(this.build_hs6_desc_hasgmap);
      } else {
        // console.log('Products found in storage');
        // alert('trying here');
        this.$store.commit(
          'setDsmCodesList',
          JSON.parse(localStorage.getItem('dsm_codes')),
        );
        // .then(this.build_hs6_desc_hasgmap);
      }
    }, // get_hscodes
  },
});

// Mount the main VUE instance with a Store, Router and Vuetify enabled
// Provide Axios support to main app
new Vue({
  store: store,
  router: router,
  vuetify: vuetify,
  axios: axios,
  render: h => {
    return h(App);
  },
}).$mount('#app');
